import { logAnalyticsEvent } from "./firebase";
import { notifyErrorByEmail } from "./notifyErrorByEmail";
import { devError } from "../utils/devLog";

const MAX_MESSAGE_LENGTH = 100;
const MAX_PARAM_LENGTH = 100;

const toErrorMessage = (error) => {
  const text = error?.message || error?.text || error?.toString?.() || "Unknown error";
  return String(text).slice(0, MAX_MESSAGE_LENGTH);
};

const sanitizeParams = (params) => {
  const sanitized = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") {
      return;
    }
    sanitized[key] = String(value).slice(0, MAX_PARAM_LENGTH);
  });

  return sanitized;
};

export const reportError = (
  error,
  { fatal = false, source = "app", params = {} } = {}
) => {
  devError(`[${source}]`, error);

  logAnalyticsEvent("exception", {
    source,
    fatal,
    error_message: toErrorMessage(error),
    ...sanitizeParams(params),
  });

  notifyErrorByEmail(error, { source, fatal, params });
};
